import { render, staticRenderFns } from "./TmallWash.vue?vue&type=template&id=1b7fc75e&scoped=true"
import script from "./TmallWash.vue?vue&type=script&lang=js"
export * from "./TmallWash.vue?vue&type=script&lang=js"
import style0 from "./TmallWash.vue?vue&type=style&index=0&id=1b7fc75e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7fc75e",
  null
  
)

export default component.exports